import React, { useState } from "react";
import "./Input.scss";

type InputProps = {
  id: string;
  label: string;
  type?: string;
  value: any;
  placeholder?: string;
  required?: boolean;
  errorMessage?: string;
  showError?: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
};

const Input: React.FC<InputProps> = ({
  id,
  label,
  type = "text",
  value,
  placeholder = "Enter value",
  required = false,
  errorMessage = "",
  showError = false,
  onChange,
  onBlur,
}) => {
  const [focused, setFocused] = useState(false);

  const handleBlur = () => {
    setFocused(false);
    if (onBlur) onBlur();
  };

  return (
    <div className="mb-3 custom-input">
      <label htmlFor={id} className="form-label input-label">
        {label} {required && <span className="text-danger">*</span>}
      </label>

      <div className="input-wrapper">
        <input
          id={id}
          type={type}
          className={`form-control 
    ${focused ? "is-focused" : ""} 
    ${showError && errorMessage ? "has-error" : ""}`}
          value={value}
          placeholder={placeholder}
          required={required}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={handleBlur}
        />

        {value && (
          <button className="clear-btn" aria-label="Clear" onClick={() => onChange("")}>
            <aui-icon
              svgclass="aui-icon-closeIcon"
              pathclass="aui-path-closeIcon"
              icon="closeIcon"
              svgwidth="13"
              svgheight="13"
              fillcolor="#6c757d"
            />
          </button>
        )}
      </div>

      {showError && errorMessage && (
        <div className="error-wrapper">
          <span className="error-text">{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default Input;
